import { render } from "./EncerrarProjeto.vue?vue&type=template&id=1b9b27c2"
import script from "./EncerrarProjeto.vue?vue&type=script&lang=js"
export * from "./EncerrarProjeto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__